<template>
  <v-row class="px-3">
    <v-col>
      <header1 class="mt-5">Aktivitäten</header1>
      <div class="ml-5 mr-5 mt-5">
        <p class="body-1">Definiere messbare Aktivitäten</p>
        <p class="body-2">Deine Lebenssäulen gliedern sich in verschiedene Aktivitäten,
          anhand derer sich deine Entwicklung vermessen lässt. Wähle einen Bereich aus, um die zugehörigen Aktivitäten
          zu definieren.
        </p>
      </div>

    <v-expansion-panels>
      <v-expansion-panel v-for="(bereich,i) in bereiche" :key="bereich.bid">
        <div style="overflow: hidden;">
          <v-expansion-panel-header>
  <!--          <rocket :color="bereich.color" style="flex: 0 1 auto;" class="mr-3"></rocket>-->
            <div :style="`position: absolute; left: -130px; top:0; width: 200px; height: 300px; background-color: ${bereich.color}; transform: rotate(-20deg); z-index:0;`" ></div>
            <div style="z-index: 1;">
              <span class="body-1 white px-1" style="border-radius: 10px;">
              {{ bereich.name }}
              </span>
              <span class="body-2 grey--text ml-2">
                ({{ (bereich.activities || []).length }})
              </span>
            </div>
            <v-spacer></v-spacer>
          </v-expansion-panel-header>
          <v-expansion-panel-content style="background-color: white; z-index: 2; position: relative;">
            <activity-group
                :bereich="bereich"
                @add_new="()=>onAddActivity(bereich)"
                @delete="(activity) => onDeleteActivity(bereich, activity)"
                @changed_order="onChangedOrder(bereich)"
            ></activity-group>
            <!--          sel: {{ bereiche[i].index }}-->
            <activity-editor v-show="bereich.index>=0"
                             :bereich="bereich" @close="bereich.index=-1"
                             :targets="targets"></activity-editor>
          </v-expansion-panel-content>
        </div>
      </v-expansion-panel>
    </v-expansion-panels>

    <div class="mt-5 text-center" v-if="numAktisLeft>1">
      Noch {{numAktisLeft}} Aktivitäten verfügbar.
    </div>
    <div class="mt-5 text-center" v-if="numAktisLeft===1">
      Noch eine Aktivität verfügbar.
    </div>
    <div class="mt-5 text-center" v-if="numAktisLeft===0">
      Keine Aktivitäten mehr verfügbar.
    </div>
    <!--    restriktionshinweis-->
<!--    <div v-if="isFree" class="text-xl-center">-->
<!--      <div class="mt-3 pa-3" style="border: 1px dashed gray; width: 100%; height: 200px; border-radius: 5px; background-color: #ffffff30">-->
<!--        <span class="headline">Mehr Aktivitäten benötigt?</span>-->
<!--        <br/><br/> Abonniere das-->
<!--        <a class="blue&#45;&#45;text" href="https://www.digistore24.com/product/396016" target="_blank">Silber-Abo</a> für insgesamt 10 oder das-->
<!--        <a class="blue&#45;&#45;text" href="https://www.digistore24.com/product/410225" target="_blank">Gold-Abo</a>-->
<!--        für insgesamt 100 Aktivitäten.-->
<!--      </div>-->
<!--    </div>-->
    <div v-if="isFree" class="text-xl-center ml-2">
      <div class="mt-3 pa-3" style="border: 1px dashed dodgerblue; width: calc( 100% - 8px); height: 220px; border-radius: 5px; background-color: #ffffff30">
        <span class="headline">Mehr Aktivitäten benötigt?</span>
        <br/><br/> Go <pro/> für insgesamt 10 Lebensbereiche bis zu 100 Aktivitäten.
        <br/><br/>
        <v-btn rounded class="d-flex mx-10 gelb dunkelblau--text" href="https://www.digistore24.com/product/410225"
               target="_blank">Upgrade auf aimz PRO</v-btn>
      </div>
    </div>
      <div class="d-flex">
        <v-btn class="mx-auto mt-3 mb-3" href="https://youtu.be/G2KGbIz-EBM" target="_blank">
          <v-icon class="mr-2">mdi-play-box-outline</v-icon>
          Videoanleitung
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue';
import Header1 from "@/components/Header1";
import Rocket from "@/components/Rocket";
import BEREICHE from "@/components/Bereiche";
import Kinds from "@/components/Kinds";
import ActivityGroup from "@/components/ActivityGroup";
import {v4 as new_guid} from 'uuid';
import ActivityEditor from "@/components/ActivityEditor";
import {ArrayX} from "@/reusable/array_extensions";
import {Ziele} from "@/components/Ziele";
import UserLib from "@/components/UserLib";
import Pro from "@/components/Pro";
const {DateTime} = require("luxon");

const CONTEXT = "@activities";

export default {
  name: "Activities",
  components: {Rocket, Header1, ActivityGroup, ActivityEditor, Pro},
  data() {
    return {
      activities_orig: {},
      activities: {
        initialized: true,
      },
      bereiche: [],
      targets:undefined,
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      var activitiesAll = await this.$backend.get_all_objects(Kinds.KIND_ACTIVITY) || [];
      var activities = activitiesAll.filter(a=>!a.deleted);
      var bereicheByName = {};
      if (!this.bereiche)
        return;
      this.$app.bereiche.forEach((b, i) => {
        if (!b.ignore) {
          b.color = BEREICHE.COLORS_BY_NAME[b.bid];
          Vue.set(b, 'activities', []);
          Vue.set(b, 'index', -1);
          b.shown = !b.ignore;
          b.nr = i; // i.e. used for sorting activities with b.nr*100+i
          this.bereiche.push(b);
          bereicheByName[b.bid] = b;
        }
      });
      if (!activities)
        return;
      activities.forEach(x => x.sortKey ||= 0);
      activities = new ArrayX(activities).sortBy(a => a.sortKey);
      activities.forEach(activity => {
        //if (!activity.name)
          //return;
        //console.log("" + activity.name + ": " + activity.sortKey);
        var b = bereicheByName[activity.bereich];
        if (!b)
          return;
        b.activities.push(activity);
      });
      var year = new Date(Date.now()).getFullYear();
      this.targets=(await this.$backend.get_object(Kinds.KIND_ZIELE, Ziele.makeId( year))||{});
    },
    onChangedOrder(bereich) {
      bereich.activities.forEach((a, i) => {
        a.sortKey = (bereich.nr + 1) * 100 + i;
        this.$backend.set_object(Kinds.KIND_ACTIVITY, a.id, a);
      });
    },
    onAddActivity(bereich) {
      console.log("onAddActivity", bereich);
      if (bereich.activities.length > 0 && !(bereich.activities[bereich.activities.length - 1].name)) {
        this.$nextTick(() => {
          Vue.set(bereich, 'index', bereich.activities.length - 1);
        });
        return;
      }
      if (this.numAktisLeft===0)
      {
        this.$events.$emit("notify", "Sie haben alle verfügbaren Aktivitäten ausgenutzt.")
        return;
      }
      var sortKey = (bereich.nr + 1) * 100 + bereich.activities.length;
      var activity = {id: new_guid(), __owner__: this.$app.user.email, name: undefined, bereich: bereich.bid, sortKey: sortKey};
      bereich.activities.push(activity)
      //bereich.index=bereich.activites.length-1;
      this.$nextTick(() => {
        Vue.set(bereich, 'index', bereich.activities.length - 1);
      });
      activity.addedDate=DateTime.fromJSDate(new Date(Date.now())).toISODate();
      this.$backend.set_object(Kinds.KIND_ACTIVITY, activity.id, activity);
    },
    onDeleteActivity(bereich, activity) {
      if (!activity)
        return;
      var idx = bereich.activities.findIndex(x => x.id === activity.id);
      if (idx >= 0)
        bereich.activities.splice(idx, 1);
      activity.deleted=true;
      activity.deleteDate=DateTime.fromJSDate(new Date(Date.now())).toISODate();
      //this.$backend.delete_object(Kinds.KIND_ACTIVITY, activity.id);
      this.$backend.set_object(Kinds.KIND_ACTIVITY, activity.id, activity);
    },
    async save() {
      this.loading = true;
      await this.$backend.set_settings(CONTEXT, this.activities, {
        onSuccess: this.onSaveSuccess,
        onError: this.onSaveError,
        no_notify: true,
      });
      this.load();
    },
    onSaveSuccess(data) {
      this.loading = false;
      this.activities_orig = data;
      this.activities = Object.assign({}, this.activities, JSON.parse(JSON.stringify(data)));
    },
    onSaveError(reason) {
      this.loading = false;
      this.error = true;
      this.reason = reason;
      this.load();
    },
  },
  computed: {
    numActivities() {
      var num=0;
      this.bereiche.forEach(b=> num+= b.activities.length);
      return num;
    },
    numAllowed() {
      if (this.$app.isTeamDashboard || this.isGold)
        return UserLib.NumActisGold;
      if (this.isFree)
        return UserLib.NumActisFree;
      if (this.isSilver)
        return UserLib.NumActisSilver;
    },
    numAktisLeft(){ return Math.max(0, this.numAllowed - this.numActivities); },
    isFree() { return this.$app.isFree; },
    isSilver() { return this.$app.isSilver; },
    isGold() { return this.$app.isGold; },
  },
  watch: {}
}
</script>

<style scoped>

</style>